module.exports = __webpack_public_path__ + "assets/img/time.893040b0.svg";